module.exports = __webpack_public_path__ + "static/media/selection-Robin_Levy.7ce8cb6b.jpg";